import React from "react";

const projects = [
  { name: "Metro Manila High-Rise", type: "Building Joints", year: "2025" },
  { name: "Visayas Coastal Bridge", type: "Modular Bridge Joints", year: "2025" },
  { name: "Cebu Commercial Complex", type: "Seismic Systems", year: "2024" },
  { name: "Mindanao Expressway Segment", type: "Strip Seal Joints", year: "2024" },
];

export default function ProjectsStrip() {
  return (
    <section className="bg-[#F5F5F5] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <p className="font-tech font-semibold uppercase tracking-[0.2em] text-[#C60018] text-sm mb-3">Track Record</p>
        <h2 className="font-heading font-extrabold uppercase text-4xl md:text-5xl tracking-wide mb-12 text-[#171717]">
          Featured Projects
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-gray-300 border border-gray-300">
          {projects.map((p) => (
            <div key={p.name} className="bg-white p-8 hover:bg-[#0A0A0A] group transition-colors duration-300">
              <p className="font-heading font-extrabold uppercase text-2xl tracking-wide text-[#171717] group-hover:text-white transition-colors">{p.name}</p>
              <p className="font-tech uppercase tracking-widest text-sm text-[#C60018] mt-3">{p.type}</p>
              <p className="text-xs text-[#6B7280] mt-2 font-tech tracking-widest">{p.year}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-[#6B7280] mt-4 font-tech uppercase tracking-widest">Representative project types — full portfolio available on request</p>
      </div>
    </section>
  );
}